export default "__VITE_ASSET__CTkOltWA__"